<div class="container">
  @if (initialized) {
    @for (site of sites; track site) {
      <div class="row">
        <div>
          <mat-form-field>
            <input matInput type="number" placeholder="{{site.name}} quantity" autocomplete="off"
              [(ngModel)]="site.quantity" />
          </mat-form-field>
        </div>
        <div class="icons">
          <button type="button" mat-icon-button aria-label="Save" color="none" (click)="save(site)">
            <mat-icon title="Save">save</mat-icon>
          </button>
        </div>
      </div>
    }
  }

</div>